import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription.tsx';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle.tsx';

const AbsencesEmpty: React.FC = () => (
  <Jumbotron>
    <JumbotronPanel>
      <JumbotronTitle>まだ欠席連絡が登録されていません</JumbotronTitle>
      <JumbotronDescription>
        欠席・遅刻・早退の連絡は下の「欠席連絡」からおこなってください。
      </JumbotronDescription>
    </JumbotronPanel>
  </Jumbotron>
);

export default AbsencesEmpty;
